/**
 * @generated SignedSource<<7b4044b6a6abd684b4b52be9bd1796d3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SendSparkInput = {
  clientMutationId?: string | null | undefined;
  toUserId?: any | null | undefined;
};
export type useSparkMutation$variables = {
  input: SendSparkInput;
};
export type useSparkMutation$data = {
  readonly sendSpark: {
    readonly query: {
      readonly currentUser: {
        readonly sparkBalance: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSparkMutation = {
  response: useSparkMutation$data;
  variables: useSparkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sparkBalance",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSparkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SendSparkPayload",
        "kind": "LinkedField",
        "name": "sendSpark",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSparkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SendSparkPayload",
        "kind": "LinkedField",
        "name": "sendSpark",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8e94e461ff68e06c24d0939a1d4fc7ec",
    "id": null,
    "metadata": {},
    "name": "useSparkMutation",
    "operationKind": "mutation",
    "text": "mutation useSparkMutation(\n  $input: SendSparkInput!\n) {\n  sendSpark(input: $input) {\n    query {\n      currentUser {\n        sparkBalance\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dff3e124adfd681ff127429f0f3a535b";

export default node;
